<template>
    <el-dialog
        :visible.sync="dialogVisible"
        :title="modalData.title"
        :show-close="false"
        width="450px"
        append-to-body
        :before-close="handleClose">
        <div class="date-select-modal-con">
            <el-form ref="form" :model="formItem" :rules="rules" label-width="80px" class="pr40">
                <el-form-item label="维度" class="label-required">
                    <ESelect v-model="formItem.select" @change="changeSelect" placeholder="请选择">
                        <el-option
                            v-for="item in optionList"
                            :key="item.value"
                            :label="item.label"
                            :value="item.value">
                        </el-option>
                    </ESelect>
                </el-form-item>
                <el-form-item :label="modalData.title" prop="data_range" class="label-required" style="margin-bottom: 0;">
                    <el-date-picker
                        :disabled="searchLoading"
                        v-model="formItem.data_range"
                        type="daterange"
                        range-separator="-"
                        start-placeholder="开始日期"
                        end-placeholder="结束日期"
                        :picker-options="pickerOptions"
                        value-format="yyyy-MM-dd"
                        style="width: 310px;">
                    </el-date-picker>
                </el-form-item>
            </el-form>
        </div>
        <div slot="footer" class="dialog-footer tac">
            <el-button type="default" @click="handleClose" class="action-btn mr20">取消</el-button>
            <el-button type="primary" @click="handleSubmit" :disabled="searchLoading" :loading="submitLoading" class="action-btn ml20">确认</el-button>
        </div>
    </el-dialog>
</template>

<script>
    import API from '@/api/dataCenter.js';
    import dayjs from 'dayjs';

    export default {
        name: "DateSelectModal",
        components: {},
        props: {
            modalData:{
                type:Object,
                required:true,
            },
            last:[String,Object],
            condition:{
                type: Array,
                required: true,
            },
            dimension:{
                type: Array,
                required: true,
            },
            rangeTime:{
                type: Array,
                required: true,
            },
            timeZone:{
                type:String,
            },
            platId:{
                type: [String,Number],
                required: true,
            },
            isTimeFilter:{
                required: false,
                type:Boolean,
                default:false,
            },
            appleAdFieldList:Array,
            appleKeywordsFieldList:Array,
        },
        data() {
            let _this = this;
            return {
                dialogVisible: false,
                submitLoading: false,
                searchLoading:false,
                formItem: {
                    data_range: [],
                    select:'',
                },
                rules: {
                    data_range: [
                        {required: true, message: '请选择日期', trigger: 'blur'},
                    ],
                    select:[
                        {required: true, message: '请选择维度', trigger: 'blur'},
                    ],
                },
                optionList:[],
                pickerOptions: {
                    firstDayOfWeek: 1,
                    disabledDate(time) {
                        let dateStr = dayjs(time).format('YYYY-MM-DD');
                        if(_this.startDate===null){
                            return true;
                        }
                        if(_this.dateAllDisabled){
                            return true;
                        }
                        if( time.getTime() < dayjs(_this.startDate).valueOf()){
                            return true;
                        }
                        if( time.getTime() > dayjs(_this.endDate).valueOf()){
                            return true;
                        }
                        return (time.getTime() > new Date().getTime())||(time.getTime() > new Date(_this.last).getTime())|| _this.notHasCostDate.includes(dateStr);
                        // return (time.getTime() > new Date().getTime())||(time.getTime() > new Date(_this.last).getTime());
                    },
                    cellClassName(time) {
                        let dateStr = dayjs(time).format('YYYY-MM-DD');
                        if(time.getTime() > new Date().getTime()){
                            return '';
                        }
                        if(_this.startDate===null){
                            return 'td-empty-date-start-modal';
                        }
                        if(_this.dateAllDisabled){
                            return 'td-empty-date-start-modal';
                        }
                        if( time.getTime() < dayjs(_this.startDate).valueOf()){
                            return 'td-empty-date-start-modal';
                        }
                        if( time.getTime() > dayjs(_this.endDate).valueOf()){
                            return 'td-empty-date-start-modal';
                        }
                        return (time.getTime() > new Date(_this.last).getTime())|| _this.notHasCostDate.includes(dateStr)?'td-empty-date-start-modal':'';
                    },
                },
                dateAllDisabled:true,
                startDate:'',
                endDate:'',
                notHasCostDate:[],
                lastSelectVal:'',
            }
        },
        computed: {
            platTimeInterval(){
                if(!this.isTimeFilter) return '';
                return 'hour';
            },
            excludeConditionFields(){
                let conConditions = this.condition.filter(item=>{
                    let fieldConfig = item.config||{};
                    return fieldConfig.type==='content';
                });
                return conConditions.filter(item=>item.isExclude).map(item=>item.name);
            },
            isPlatAll(){
                return this.$route.name==='data_all';
            },
        },
        mounted(){
            $('body').on('mouseover','.td-empty-date-start-modal',function(e){
                let $target = $(e.target);
                $target.attr('title', '根据选择的条件该日期无开投日期');
            })
        },
        methods: {
            handleClose() {
                this.dialogVisible = false;
                this.resetForm();
                this.$emit('close',this.modalData);
            },
            resetForm() {
                this.formItem.range_time = [];
                this.submitLoading = false;
                this.$refs['form'].resetFields();
            },
            showModal() {
                this.dialogVisible = true;
                if(this.modalData.name=='start_date'){
                    if(this.isPlatAll){
                        this.optionList = [
                            {
                                value:'bloc_name',
                                label:'按集团',
                            },
                            {
                                value:'company_name',
                                label:'按客户',
                            },
                            {
                                value:'account_name',
                                label:'按账户',
                            },
                            {
                                value:'project_name',
                                label:'按项目',
                            },
                            {
                                value:'subproject_name',
                                label:'按推广',
                            },
                            {
                                value:'plan_name',
                                label:'按计划',
                            },
                            {
                                value:'adgroup_name',
                                label:'按广告组',
                            },
                        ];
                    }else if(this.platId=='3'){
                        this.optionList = [
                            {
                                value:'bloc_name',
                                label:'按集团',
                            },
                            {
                                value:'company_name',
                                label:'按客户',
                            },
                            {
                                value:'account_name',
                                label:'按账户',
                            },
                            {
                                value:'project_name',
                                label:'按项目',
                            },
                            {
                                value:'subproject_name',
                                label:'按推广',
                            },
                            {
                                value:'app_name',
                                label:'按产品',
                            },
                            {
                                value:'plan_name',
                                label:'按计划',
                            },
                            {
                                value:'adgroup_name',
                                label:'按广告组',
                            },
                            {
                                value:'ad_name',
                                label:'按广告',
                            },
                            {
                                value:'idea_name',
                                label:'按创意',
                            },
                        ];
                    }else if(this.platId=='4'){
                        this.optionList = [
                            {
                                label:'按集团',
                                value:'bloc_name',
                            },
                            {
                                label:'按客户',
                                value:'company_name',
                            },
                            {
                                label:'按账户',
                                value:'account_name',
                            },
                            {
                                value:'project_name',
                                label:'按项目',
                            },
                            {
                                value:'subproject_name',
                                label:'按推广',
                            },
                            {
                                label:'按产品',
                                value:'app_name',
                            },
                            {
                                label:'按任务',
                                value:'task_name',
                            },
                            {
                                label:'按子任务',
                                value:'sub_task_name',
                            },
                        ];
                    }else if(this.platId=='8'){
                        this.optionList = [
                            {
                                value:'bloc_name',
                                label:'按集团',
                            },
                            {
                                value:'company_name',
                                label:'按客户',
                            },
                            {
                                value:'account_name',
                                label:'按账户',
                            },
                            {
                                value:'project_name',
                                label:'按项目',
                            },
                            {
                                value:'subproject_name',
                                label:'按推广',
                            },
                            {
                                value:'app_name',
                                label:'按产品',
                            },
                            {
                                value:'plan_name',
                                label:'按广告系列',
                            },
                            {
                                value:'adgroup_name',
                                label:'按广告',
                            },
                            {
                                value:'ad_name',
                                label:'按创意',
                            },
                        ];
                    } else if(this.platId=='9'){
                        this.optionList = [
                            {
                                value:'bloc_name',
                                label:'按集团名称',
                            },
                            {
                                value:'company_name',
                                label:'按客户',
                            },
                            {
                                value:'account_name',
                                label:'按广告系列组',
                            },
                            {
                                value:'project_name',
                                label:'按项目',
                            },
                            {
                                value:'subproject_name',
                                label:'按推广',
                            },
                            {
                                value:'app_name',
                                label:'按产品',
                            },
                            {
                                value:'plan_name',
                                label:'按广告系列',
                            },
                            {
                                value:'adgroup_name',
                                label:'按广告组',
                            },
                            {
                                value:'keyword',
                                label:'按关键词',
                            },
                            {
                                value:'search_term',
                                label:'按搜索词',
                            },
                            {
                                value:'ad_name',
                                label:'按广告',
                            },
                        ].filter(item=>{
                            if(this.isTimeFilter){
                                return item.value!='search_term'&&item.value!='ad_name'&&item.value!='ad_create_date';
                            }else{
                                return true;
                            }
                        });
                    }else if(this.platId=='7'){
                        this.optionList = [
                            {
                                value:'bloc_name',
                                label:'按集团',
                            },
                            {
                                value:'company_name',
                                label:'按客户',
                            },
                            {
                                value:'account_name',
                                label:'按账户',
                            },
                            {
                                value:'project_name',
                                label:'按项目',
                            },
                            {
                                value:'subproject_name',
                                label:'按推广',
                            },
                            {
                                value:'app_name',
                                label:'按产品',
                            },
                            {
                                value:'plan_name',
                                label:'按计划',
                            },
                            {
                                value:'adgroup_name',
                                label:'按广告组',
                            },
                            {
                                value:'ad_name',
                                label:'按创意',
                            },
                        ];
                    }else if(this.platId=='12'){
                        this.optionList = [
                            {
                                value:'bloc_name',
                                label:'按集团',
                            },
                            {
                                value:'company_name',
                                label:'按客户',
                            },
                            {
                                value:'account_name',
                                label:'按账户',
                            },
                            {
                                value:'plan_name',
                                label:'按计划',
                            },
                            {
                                value:'adgroup_name',
                                label:'按广告组',
                            },
                            {
                                value:'ad_name',
                                label:'按创意',
                            },
                        ];
                    }else if( this.platId=='37'){
                        this.optionList = [
                            {
                                value:'bloc_name',
                                label:'按集团',
                            },
                            {
                                value:'company_name',
                                label:'按客户',
                            },
                            {
                                value:'account_name',
                                label:'按账户',
                            },
                            {
                                value:'project_name',
                                label:'按项目',
                            },
                            {
                                value:'subproject_name',
                                label:'按推广',
                            },
                            {
                                value:'app_name',
                                label:'按产品',
                            },
                            {
                                value:'plan_name',
                                label:'按计划',
                            },
                            {
                                value:'ad_name',
                                label:'按创意',
                            },
                        ];
                    }
                    else if(this.platId=='10'||this.platId=='11') {
                        this.optionList = [
                            {
                                value:'bloc_name',
                                label:'按集团',
                            },
                            {
                                value:'company_name',
                                label:'按客户',
                            },
                            {
                                value:'account_name',
                                label:'按账户',
                            },
                            {
                                value:'project_name',
                                label:'按项目',
                            },
                            {
                                value:'subproject_name',
                                label:'按推广',
                            },
                            {
                                value:'app_name',
                                label:'按产品',
                            },
                            {
                                value:'plan_name',
                                label:'按计划',
                            },
                            {
                                value:'adgroup_name',
                                label:this.platId=='11'?'按分组':'按任务',
                            },
                            {
                                value:'ad_name',
                                label:'按创意',
                            },
                        ];
                    }
                    else{
                        this.optionList = [
                            {
                                value:'bloc_name',
                                label:'按集团',
                            },
                            {
                                value:'company_name',
                                label:'按客户',
                            },
                            {
                                value:'account_name',
                                label:'按账户',
                            },
                            {
                                value:'project_name',
                                label:'按项目',
                            },
                            {
                                value:'subproject_name',
                                label:'按推广',
                            },
                            {
                                value:'app_name',
                                label:'按产品',
                            },
                            {
                                value:'plan_name',
                                label:'按计划',
                            },
                            {
                                value:'adgroup_name',
                                label:'按广告组',
                            },
                            {
                                value:'ad_name',
                                label:'按创意',
                            },
                        ];
                    }

                }else if(this.modalData.name=='create_date'){
                    if(this.isPlatAll){
                        this.optionList = [
                            {
                                label:'按账户',
                                value:'account_create_time',
                            },
                            {
                                label:'按计划',
                                value:'plan_create_date',
                            },
                            {
                                label:'按广告组',
                                value:'adgroup_create_date',
                            },
                        ];
                    }else if(this.platId=='3'){
                        this.optionList = [
                            {
                                label:'按账户',
                                value:'account_create_time',
                            },
                            {
                                label:'按计划',
                                value:'plan_create_date',
                            },
                            {
                                label:'按广告组',
                                value:'adgroup_create_date',
                            },
                            {
                                label:'按广告',
                                value:'ad_create_date',
                            },
                            {
                                label:'按创意',
                                value:'idea_create_date',
                            },
                        ];
                    }else if(this.platId=='4'){
                        this.optionList = [
                            {
                                label:'按账户',
                                value:'account_create_time',
                            },
                            {
                                label:'按任务',
                                value:'task_create_date',
                            },
                            {
                                label:'按子任务',
                                value:'sub_task_create_date',
                            },
                        ];
                    }else if(this.platId=='8'){
                        this.optionList = [
                            {
                                label:'按账户',
                                value:'account_create_time',
                            },
                            {
                                label:'按广告系列',
                                value:'plan_create_date',
                            },
                            {
                                label:'按广告',
                                value:'adgroup_create_date',
                            },
                            {
                                label:'按创意',
                                value:'ad_create_date',
                            },
                        ];
                    }else if(this.platId=='9'){
                        this.optionList = [
                            {
                                label:'按广告系列',
                                value:'plan_create_date',
                            },
                            {
                                label:'按广告组',
                                value:'adgroup_create_date',
                            },
                            {
                                label:'按关键词',
                                value:'keyword_create_date',
                            },
                            {
                                label:'按广告',
                                value:'ad_create_date',
                            },
                        ].filter(item=>{
                            if(this.isTimeFilter){
                                return item.value!='search_term'&&item.value!='ad_name'&&item.value!='ad_create_date';
                            }else{
                                return true;
                            }
                        });
                    }else if(this.platId=='10'||this.platId=='11') {
                        this.optionList = [
                            {
                                label:'按账户',
                                value:'account_create_time',
                            },
                            {
                                label:'按计划',
                                value:'plan_create_date',
                            },
                            {
                                label:this.platId=='11'?'按分组':'按任务',
                                value:'adgroup_create_date',
                            },
                            {
                                label:'按创意',
                                value:'ad_create_date',
                            },
                        ];
                    }else if(this.platId=='37'){
                        this.optionList = [
                            {
                                label:'按账户',
                                value:'account_create_time',
                            },
                            {
                                label:'按计划',
                                value:'plan_create_date',
                            },
                            {
                                label:'按创意',
                                value:'ad_create_date',
                            },
                        ]
                    }else if(this.platId=='12'){
                        this.optionList = [
                            // {
                            //     label:'按账户',
                            //     value:'account_create_time',
                            // },
                            {
                                label:'按计划',
                                value:'plan_create_date',
                            },
                            {
                                label:'按广告组',
                                value:'adgroup_create_date',
                            },
                            {
                                label:'按创意',
                                value:'ad_create_date',
                            },
                        ];
                    }
                    else{
                        this.optionList = [
                            {
                                label:'按账户',
                                value:'account_create_time',
                            },
                            {
                                label:'按计划',
                                value:'plan_create_date',
                            },
                            {
                                label:'按广告组',
                                value:'adgroup_create_date',
                            },
                            {
                                label:'按创意',
                                value:'ad_create_date',
                            },
                        ];
                    }
                }
                this.formItem.data_range = this.modalData.dateValue||[];


                let defaultVal = '';
                if(this.isPlatAll){
                    defaultVal = this.modalData.name=='start_date'?'subproject_name':this.modalData.name=='create_date'?'account_create_time':'';
                }else if(this.platId=='9'){
                    defaultVal = this.modalData.name=='start_date'?'app_name':this.modalData.name=='create_date'?'plan_create_date':'';
                }else if(this.platId=='12'){
                    defaultVal = this.modalData.name=='start_date'?'account_name':this.modalData.name=='create_date'?'plan_create_date':'';
                }else{
                    defaultVal = this.modalData.name=='start_date'?'app_name':this.modalData.name=='create_date'?'account_create_time':'';
                }
                this.formItem.select = this.modalData.selectValue||defaultVal;
                this.lastSelectVal = this.formItem.select;
                this.getConditions();
            },
            changeSelect(val){
                if(this.platId=='9'){
                    let formGroup = this.dimension;
                    let groupCreateDate = formGroup.find(item=>item.name=='create_date');
                    let groupStartDate = formGroup.find(item=>item.name=='start_date');

                    let adFieldList = this.appleAdFieldList;
                    let isGroupHasAd = formGroup.map(item=>item.name).some(item=>adFieldList.includes(item));
                    let isGroupCreateDateAd = (groupCreateDate?.dimensionValue?.create_date_dimension||'') == 'ad_create_date';
                    let isGroupStartDateAd = (groupStartDate?.dimensionValue?.start_date_dimension||'') == 'ad_name';

                    let formCondition = this.condition.filter(item=>item.name!=this.modalData.name);
                    let conditionCreateDate = formCondition.find(item=>item.name=='create_date');
                    let conditionStartDate = formCondition.find(item=>item.name=='start_date');

                    let isConditionHasAd = formCondition.map(item=>item.name).some(item=>adFieldList.includes(item));
                    let isConditionCreateDateAd = (conditionCreateDate?.selectValue||'') == 'ad_create_date';
                    let isConditionStartDateAd = (conditionStartDate?.selectValue||'') == 'ad_name';
                    let isAppleAdChecked = isGroupHasAd||isGroupCreateDateAd||isGroupStartDateAd||isConditionHasAd||isConditionCreateDateAd||isConditionStartDateAd;


                    let keywordsFieldList = this.appleKeywordsFieldList;
                    let isGroupHasKeywords = formGroup.map(item=>item.name).some(item=>keywordsFieldList.includes(item));

                    let groupYYType = formGroup.find(item=>item.name=='yy_type');
                    let isGroupYYTypeKeywords = (groupYYType?.dimensionValue?.yy_type_dimension||'') == 'keyword_yy_type';
                    let isGroupCreateDateKeywords = (groupCreateDate?.dimensionValue?.create_date_dimension||'') == 'keyword_create_date';
                    let isGroupStartDateKeywords = (groupStartDate?.dimensionValue?.start_date_dimension||'') == 'keyword';
                    let isGroupStartDateSearchTerm = (groupStartDate?.dimensionValue?.start_date_dimension||'') == 'search_term';

                    let isConditionHasKeywords = formCondition.map(item=>item.name).some(item=>keywordsFieldList.includes(item));
                    let conditionYYType = formCondition.find(item=>item.name=='yy_type');
                    let isConditionYYTypeKeywords = (conditionYYType?.selectValue||'') == 'keyword_yy_type';
                    let isConditionCreateDateKeywords = (conditionCreateDate?.selectValue||'') == 'keyword_create_date';
                    let isConditionStartDateKeywords = (conditionStartDate?.selectValue||'') == 'keyword';
                    let isConditionStartDateSearchTerm = (conditionStartDate?.selectValue||'') == 'search_term';

                    let isAppleKeywordsChecked = isGroupHasKeywords||isGroupYYTypeKeywords||isGroupCreateDateKeywords||isGroupStartDateKeywords||isGroupStartDateSearchTerm||isConditionHasKeywords||isConditionYYTypeKeywords||isConditionCreateDateKeywords||isConditionStartDateKeywords||isConditionStartDateSearchTerm;

                    if(isAppleAdChecked&&(val=='keyword'||val=='search_term'||val=='keyword_create_date')){
                        /* 页面已选广告相关，弹窗里又选了关键字 */
                        let groupAdList = [];
                        let conditionAdList = [];
                        this.dimension.forEach(item=>{
                            if(this.appleAdFieldList.includes(item.name)){
                                groupAdList.push({...item});
                            }
                        });
                        this.condition.forEach(item=>{
                            if(this.appleAdFieldList.includes(item.name)){
                                conditionAdList.push({...item});
                            }
                        });

                        let groupTextList = groupAdList.map(item=>item.display_name);
                        let conditionTextList = conditionAdList.map(item=>item.display_name);
                        let restGroup = [];
                        let restCondition = [];

                        if(isGroupCreateDateAd){
                            groupTextList.push('创建日期(按广告)');
                            restGroup.push('create_date');
                        }
                        if(isGroupStartDateAd){
                            groupTextList.push('开投日期(按广告)');
                            restGroup.push('start_date');
                        }
                        if(isConditionCreateDateAd){
                            conditionTextList.push('创建日期(按广告)');
                            restCondition.push('create_date');
                        }
                        if(isConditionStartDateAd){
                            conditionTextList.push('开投日期(按广告)');
                            restCondition.push('start_date');
                        }


                        let groupText = groupTextList.length>0?`<p><span class="text-bold">维度：</span>${groupTextList.join('、')}</p>`:'';
                        let conditionText = conditionTextList.length>0?`<p><span class="text-bold">筛选：</span>${conditionTextList.join('、')}</p>`:'';
                        let htmlStr = `<div><p>关键词相关维度与广告相关维度不能同时维度分组或筛选，是否继续？</p><p class="text-color-error text-bold">继续将删除以下已选维度或筛选！</p>${groupText}${conditionText}</div>`;
                        this.$confirm(htmlStr,'提示',{
                            confirmButtonText: '继续',
                            cancelButtonText: '取消',
                            type: 'warning',
                            dangerouslyUseHTMLString: true,
                            customClass:'wide-confirm-box-550',
                        }).then(()=>{
                            console.log('继续');
                            this.$emit('remove-apple-form',groupAdList.map(item=>item.name).concat(restGroup),conditionAdList.map(item=>item.name).concat(restCondition),true);
                            this.$nextTick(()=>{
                                this.lastSelectVal = val;
                                this.formItem.data_range = [];
                                this.getConditions();
                            })
                        }).catch(()=>{
                            console.log('取消');
                            this.$set(this.formItem,'select',this.lastSelectVal);
                        })

                    }else if(isAppleKeywordsChecked&&(val=='ad_name'||val=='ad_create_date')){
                        /* 页面已选关键字相关，弹窗里又选了广告 */
                        let groupKeywordList = [];
                        let conditionKeywordList = [];
                        formGroup.forEach(item=>{
                            if(this.appleKeywordsFieldList.includes(item.name)){
                                groupKeywordList.push({...item});
                            }
                        });
                        formCondition.forEach(item=>{
                            if(this.appleKeywordsFieldList.includes(item.name)){
                                conditionKeywordList.push({...item});
                            }
                        });


                        let groupTextList = groupKeywordList.map(item=>item.display_name);
                        let conditionTextList = conditionKeywordList.map(item=>item.display_name);
                        let restGroup = [];
                        let restCondition = [];
                        if(isGroupYYTypeKeywords){
                            groupTextList.push('运营类型(关键词)');
                            restGroup.push('yy_type');
                        }
                        if(isGroupCreateDateKeywords){
                            groupTextList.push('创建日期(关键词)');
                            restGroup.push('create_date');
                        }
                        if(isGroupStartDateKeywords){
                            groupTextList.push('开投日期(关键词)');
                            restGroup.push('start_date');
                        }
                        if(isGroupStartDateSearchTerm){
                            groupTextList.push('开投日期(搜索词)');
                            if(!restGroup.includes('start_date')){
                                restGroup.push('start_date');
                            }
                        }

                        if(isConditionYYTypeKeywords){
                            conditionTextList.push('运营类型(关键词)');
                            restCondition.push('yy_type');
                        }
                        if(isConditionCreateDateKeywords){
                            conditionTextList.push('创建日期(关键词)');
                            restCondition.push('create_date');
                        }
                        if(isConditionStartDateKeywords){
                            conditionTextList.push('开投日期(关键词)');
                            restCondition.push('start_date');
                        }
                        if(isConditionStartDateSearchTerm){
                            conditionTextList.push('开投日期(搜索词)');
                            if(!restCondition.includes('start_date')){
                                restCondition.push('start_date');
                            }
                        }

                        let groupText = groupTextList.length>0?`<p><span class="text-bold">维度：</span>${groupTextList.join('、')}</p>`:'';
                        let conditionText = conditionTextList.length>0?`<p><span class="text-bold">筛选：</span>${conditionTextList.join('、')}</p>`:'';
                        let htmlStr = `<div><p>关键词相关维度与广告相关维度不能同时维度分组或筛选，是否继续？</p><p class="text-color-error text-bold">继续将删除以下已选维度或筛选！</p>${groupText}${conditionText}</div>`;
                        this.$confirm(htmlStr,'提示',{
                            confirmButtonText: '继续',
                            cancelButtonText: '取消',
                            type: 'warning',
                            dangerouslyUseHTMLString: true,
                            customClass:'wide-confirm-box-550',
                        }).then(()=>{
                            console.log('继续');
                            this.$emit('remove-apple-form',groupKeywordList.map(item=>item.name).concat(restGroup),conditionKeywordList.map(item=>item.name).concat(restCondition));

                            this.$nextTick(()=>{
                                this.lastSelectVal = val;
                                this.formItem.data_range = [];
                                this.getConditions();
                            });
                        }).catch(()=>{
                            console.log('取消');
                            this.$set(this.formItem,'select',this.lastSelectVal);
                        })
                    }else{
                        this.formItem.data_range = [];
                        this.getConditions();
                    }
                }else{
                    this.formItem.data_range = [];
                    this.getConditions();
                }
            },
            handleSubmit() {
                this.$refs['form'].validate((valid) => {
                    if (valid) {
                        let selectItem = this.optionList.find(item=>item.value==this.formItem.select)||{};
                        this.$emit('save-value',this.modalData,{
                            date:this.formItem.data_range,
                            select:this.formItem.select,
                            selectLabel:selectItem.label,
                        },'date_select');
                        this.dialogVisible = false;
                        this.resetForm();
                    } else {
                        return false;
                    }
                });
            },
            getConditions(){
                this.searchLoading = true;

                let conditionData = {};

                this.condition.forEach(item=>{
                    let config = item.config||{};
                    if(config.type=='date_select'){
                        conditionData[item.name] = item.dateValue.join('/');
                        if(item.name=='start_date'){
                            conditionData.start_date_dimension = item.selectValue;
                        }else if(item.name=='create_date'){
                            conditionData.create_date_dimension = item.selectValue;
                        }
                    }else if(config.type=='date'){
                        conditionData[item.name] = item.dateValue.join('/');
                    }else if(config.type=='time'){
                        conditionData[item.name] = item.timeValue.join('/');
                    }else if(config.type=='select'){
                        conditionData[item.name] = item.selectValue;
                    }else{
                        if(item.name=='yy_type'){
                            conditionData.yy_type_dimension = item.selectValue;
                        }
                        conditionData[item.name] = (item.contentValue||[]).map(item=>item.id);
                    }
                });

                let apiType = 'getPlatConditions';
                if(this.platId == '1'){
                    apiType = 'getOPPOConditions';
                }else if(this.platId == '3'){
                    apiType = 'getVivoConditions';
                }else if(this.platId == '4'){
                    apiType = 'getHuaweiConditions';
                }else if(this.platId == '7'){
                    apiType = 'getMiConditions';
                }else if(this.platId == '8'){
                    apiType = 'getIQiYiConditions';
                }else if(this.platId == '9'){
                    apiType = 'getAppleConditions';
                }else if(this.platId == '10'){
                    apiType = 'getHuaweiADSConditions';
                }else if(this.platId == '11'){
                    apiType = 'getHonorConditions';
                }else if(this.platId == '37'){
                    apiType = 'getMiv4Conditions';
                }else if(this.platId == '12'){
                    apiType = 'getMiGlobalConditions';
                }

                let reqData = {
                    return_condition: this.modalData.name+'|'+this.formItem.select,
                    condition:conditionData,
                    exclude_condition_fields:this.excludeConditionFields.join(','),
                    range_time: this.rangeTime.join('/'),
                };
                if(this.platId=='9'||this.platId=='4'||!this.platId){
                    reqData.time_zone = this.timeZone;
                    /* 后端分表查询需要用到group数据，仅Apple渠道和整体 和华为渠道 */
                    reqData.group = (this.dimension||[]).map(item => {
                        let value = item.dimensionValue || {};
                        let groupVal = {
                            group_by: item.name,
                        };
                        if(value.start_date_dimension){
                            groupVal.start_date_dimension = value.start_date_dimension;
                        }
                        if(value.create_date_dimension){
                            groupVal.create_date_dimension = value.create_date_dimension;
                        }
                        if(value.yy_type_dimension){
                            groupVal.yy_type_dimension = value.yy_type_dimension;
                        }
                        return groupVal;
                    });
                }
                if(this.isTimeFilter){
                    reqData.time_interval = this.platTimeInterval;
                }

                API[apiType](reqData).then(res => {
                    this.searchLoading = false;
                    // let resData = res.data || [];
                    let resData = (res.data||{}).list||[];
                    this.dateAllDisabled = resData.all_disabled;
                    this.startDate = resData.start_date+'';
                    this.endDate = resData.end_date+'';
                    this.notHasCostDate = (resData.not_has_cost_date || []).map(item=>{
                        return dayjs(''+item).format('YYYY-MM-DD');
                    });

                }, (err) => {
                    console.log('getConditions error', err);
                    this.searchLoading = false;

                    // this.$message.error(err.info||'请求有误');
                    let errCondition = err.data || [];
                    if (errCondition.length > 0) {

                        let errStr = '';
                        errCondition.forEach(item=>{
                            errStr = errStr + `<p class="pb6"><span class="text-bold">${item.err_title}</span>${(item.err_msg||[]).join('，')}</p>`;
                        });
                        let htmlStr = `<div class="tal" style="max-height: 300px;overflow: auto;">${errStr}</div>`;

                        this.$confirm(htmlStr, '以下已选条件无权限', {
                            showCancelButton: false,
                            confirmButtonText: '我知道了',
                            type: 'error',
                            center: true,
                            dangerouslyUseHTMLString: true,
                            showClose: false,
                            distinguishCancelAndClose: true,
                            closeOnClickModal: false,
                            closeOnPressEscape: false,
                        });
                    }else{
                        this.$message.error(err.info||'请求有误');
                    }
                });
            },
        }
    }
</script>

<style lang="scss" scoped>
    .action-btn {
        /*width: 120px;*/
    }

    ::v-deep .el-dialog__body{
        padding: 20px;
    }

    ::v-deep.date-select-modal-con .el-date-editor.is-disabled{
        pointer-events: none;
    }

</style>
